import { create } from 'zustand';
import { applicationsService } from 'src/services/applications';
import type { Application } from 'src/services/application-reviews';

interface ApplicationsState {
  current?: Application | null;
  loading: boolean;
  error: string | null;

  get: (id: string | number) => Promise<void>;
  getPayloadHtml: (id: string | number) => Promise<string>;
  getPayloadPdfUrl: (id: string | number) => Promise<string>;
  getContractPdfUrl: (id: string | number) => Promise<string>;
  getContractZipUrl: (id: string | number) => Promise<string>;
}

export const useApplicationsStore = create<ApplicationsState>((set) => ({
  current: null,
  loading: false,
  error: null,

  get: async (id) => {
    set({ loading: true, error: null });
    try {
      const data = await applicationsService.get(id);
      set({ current: data });
    } catch (error: unknown) {
      set({ error: (error as { message?: string })?.message || 'Failed to load application' });
      throw error;
    } finally {
      set({ loading: false });
    }
  },

  getPayloadHtml: async (id) => {
    const html = await applicationsService.getPayloadHtml(id);
    return html;
  },

  getPayloadPdfUrl: async (id) => {
    const blob = await applicationsService.getPayloadPdf(id);
    return URL.createObjectURL(blob);
  },

  getContractPdfUrl: async (id) => {
    const blob = await applicationsService.getContractPdf(id);
    return URL.createObjectURL(blob);
  },

  getContractZipUrl: async (id) => {
    const blob = await applicationsService.getContractZip(id);
    return URL.createObjectURL(blob);
  },
}));


